const PALETTE = [
  { bg: "#EFF6FF", text: "#1D4ED8", border: "#3B82F6" }, // blue
  { bg: "#ECFDF5", text: "#047857", border: "#10B981" }, // green
  { bg: "#FEF3C7", text: "#92400E", border: "#F59E0B" }, // amber
  { bg: "#FCE7F3", text: "#9D174D", border: "#EC4899" }, // pink
  { bg: "#F3E8FF", text: "#6D28D9", border: "#A855F7" }, // purple
  { bg: "#E0F2FE", text: "#0369A1", border: "#0EA5E9" }, // sky
  { bg: "#FFEDD5", text: "#9A3412", border: "#F97316" }, // orange
  { bg: "#CCFBF1", text: "#0F766E", border: "#14B8A6" }, // teal
];

function pick(name) {
  let h = 0;
  for (let i = 0; i < name.length; i++) h = (h * 31 + name.charCodeAt(i)) >>> 0;
  return PALETTE[h % PALETTE.length];
}

export function CreatorBadge({ name, testId }) {
  const label = (name || "").trim();
  if (!label) return <span className="text-xs text-[#94A3B8]">—</span>;
  const c = pick(label.toLowerCase());
  return (
    <span
      data-testid={testId}
      className="inline-block text-[11px] font-medium px-2 py-0.5 rounded-full border max-w-[130px] truncate align-middle"
      style={{ backgroundColor: c.bg, color: c.text, borderColor: c.border }}
      title={label}
    >
      {label}
    </span>
  );
}
